import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import NavItem from "views/components/sidebar/NavItem";
import useViewsDispatch from "views/stores/useViewsDispatch";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectUndoRedoAvailability } from "views/logic/slices/undoRedoSelectors";
import { undo } from "views/logic/slices/undoRedoActions";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useHotkey from "hooks/useHotkey";
import useViewType from "views/hooks/useViewType";
const UndoNavItem = ({ sidebarIsPinned }) => {
  const { t } = useTranslation("search");
  const viewType = useViewType();
  const dispatch = useViewsDispatch();
  const { isUndoAvailable } = useViewsSelector(selectUndoRedoAvailability);
  const sendTelemetry = useSendTelemetry();
  const onClick = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_SIDEBAR_UNDO, {
      app_action_value: "search-sidebar-undo"
    });
    return dispatch(undo());
  }, [dispatch, sendTelemetry]);
  useHotkey({
    actionKey: "undo",
    callback: () => dispatch(undo()),
    scope: viewType.toLowerCase()
  });
  return /* @__PURE__ */ React.createElement(
    NavItem,
    {
      disabled: !isUndoAvailable,
      onClick,
      icon: "undo",
      title: t("undo_redo.undo"),
      ariaLabel: t("undo_redo.undo"),
      sidebarIsPinned
    }
  );
};
export default UndoNavItem;
